import {
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import ESigningRequestPreparingImageBuyer from 'assets/images/ESigningRequestPreparingImageBuyer.png';
import { poppins300 } from 'theme/common.style';
import CustomStepperAgent from '../CustomStepperAgent';
import FinalContractUploadDialog from 'component/BuyerRegistration/components/FinalContractUploadDialog';
import PrepareContractSignDialog from 'component/BuyerRegistration/components/PrepareContractSignDialog';
import { CONTRACT_FILE_UPLOAD } from 'constant/app.config';
import { postApiCall } from 'api/apiService';

const Step4VendorContractESignNowAgent = (props) => {
  const { bannerDetails } = props;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const [openPrepareDialog, setOpenPrepareDialog] = useState(false);
  const [openFinalContractDialog, setOpenFinalContractDialog] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [uploadedContractUrl, setUploadedContractUrl] = useState(null);
  const [signBuyerId, setSignBuyerId] = useState(0);
  const vendorId = bannerDetails?.propertyOwnerDetails?.find(
    (item) => item?.isPrimary === 1
  )?.user?.userId;

  const handleOpenFinalContractDialog = () => {
    setOpenFinalContractDialog(true);
  };
  const handleCloseFinalContractDialog = () => {
    setOpenFinalContractDialog(false);
  };

  const handleFinalContractSubmit = async (file, buyerIdFromSelection) => {
    setUploadedPdf(file);
    setSignBuyerId(buyerIdFromSelection || 0);
    setOpenPrepareDialog(true);
    try {
      const formData = new FormData();
      formData.append('propertyId', Number(bannerDetails?.propertyId));
      formData.append('vendorId', [vendorId]);
      formData.append('buyerId', 0);
      formData.append('contractFile', file);
      const response = await postApiCall(CONTRACT_FILE_UPLOAD, formData);

      if (response?.data?.status === 1) {
        setUploadedContractUrl(response.data.contractFile);
      }
    } catch (error) {}
  };

  // const getPrimaryUserFullName = (ownerDetails) => {
  //   const primary = ownerDetails?.find((item) => item.isPrimary === 1);
  //   return primary
  //     ? `${primary?.user?.userName} ${primary?.user?.userSurName}`
  //     : 'Not Found';
  // };

  const getPrimaryUserFullName = (ownerDetails) => {
    return (
      ownerDetails?.propertyOwnerDetails
        ?.map((item) => `${item?.user?.userName} ${item?.user?.userSurName}`)
        .join(', ') || 'Not Found'
    );
  };

  const ownerFullName = getPrimaryUserFullName(bannerDetails);

  const vendorName = ownerFullName;

  const handleClosePrepareDialog = () => {
    setOpenPrepareDialog(false);
  };

  const handleCloseAllContractDialogs = () => {
    setOpenPrepareDialog(false);
    setOpenFinalContractDialog(false);
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: '#A444AD',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '0 0 10px 0' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container xs={12} md={12}>
          <Grid item container xs={12} md={9}>
            <Grid item xs={12}>
              <Stack
                direction={'column'}
                padding={matchessm ? '10px 10px 0 10px' : '30px 0 0 33px'}
              >
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: 300,
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  {bannerDetails?.propertyAddress}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '26px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: 1,
                  }}
                >
                  Prepare {vendorName}’s Contract for E-Signing Now!
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Prepare the Contract of Sale for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.propertyAddress}
                  </Typography>
                  &nbsp;and send the E-sign request to the Vendor{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {vendorName}{' '}
                  </Typography>
                  now.
                </Typography>
              </Stack>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: 'flex',
                  justifyContent: matchessm ? 'space-between' : 'start',
                  gap: matchessm ? 1 : 2,
                  padding: matchessm ? '0 10px 0 10px' : '0 0 0 33px',
                }}
              >
                <Button
                  onClick={handleOpenFinalContractDialog}
                  sx={{
                    width: matchessm ? 'auto' : '165px',
                    gap: matchessm ? '5px' : '10px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: '#FFFFFF',
                    color: '#A444AD',
                    '&:hover': {
                      bgcolor: '#FFFFFF',
                      color: '#A444AD',
                    },
                  }}
                >
                  Prepare Contract
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} alignItems={'center'}>
                <CustomStepperAgent stepValue={1} requestEsign={true} />
              </Grid>
            </Grid>
          </Grid>
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={ESigningRequestPreparingImageBuyer}
                alt="ESigningRequestPreparingImageBuyer"
                style={{
                  objectFit: 'contain',
                  height: '257px',
                  width: '264px',
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
      {openFinalContractDialog && (
        <FinalContractUploadDialog
          open={openFinalContractDialog}
          onClose={handleCloseFinalContractDialog}
          onSubmit={handleFinalContractSubmit}
          streetName={bannerDetails?.propertyAddress}
          matchessm={matchessm}
          userType={'Agent'}
          propertyIdbanner={Number(bannerDetails?.propertyId)}
          isVendorContainer={true}
        />
      )}
      {openPrepareDialog && (
        <PrepareContractSignDialog
          open={openPrepareDialog}
          onCancel={handleClosePrepareDialog}
          onSuccess={handleCloseAllContractDialogs}
          pdfFile={uploadedPdf}
          streetName={bannerDetails?.propertyAddress}
          matchessm={matchessm}
          contractFileUrl={uploadedContractUrl}
          propertyId={Number(bannerDetails?.propertyId)}
          vendorId={vendorId}
          VendorContainer={true}
          fromDashboard={true}
          userName={vendorName}
          signBuyerId={signBuyerId}
          propertyOwnerDetails={bannerDetails?.propertyOwnerDetails}
        />
      )}
    </>
  );
};

export default Step4VendorContractESignNowAgent;
